import { render } from "./App.vue?vue&type=template&id=0ed49714&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0ed49714&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dominika\\Documents\\programowanie\\stonki\\nidomika.github.io\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed49714"]])

export default __exports__